import {
    INPUT_SEARCH_TEXT,
    CLEAN_SEARCH_TEXT,
    UPDATE_FILTERS,
    UPDATE_FILTER,
    SET_FILTERS_LIST_VALUES,
    TOGGLE_FOOTER,
    SAVE_SEARCH_RESULTS,
    SAVE_DATE_RESULTS,
    SAVE_RESULT,
    SAVE_BORRADOR,
    SAVE_BORRADOR_CONCEPTO,
    DELETE_SAVED_RESULT,
    DELETE_SAVED_BORRADOR,
    DELETE_SAVED_BORRADOR_KEY,
    DELETE_ALL_BORRADOR,
    SET_DOC_SEARCH,
    SET_LOADING_RESULTS,
    SET_LOADING_RESULTS_FALSE,
    SET_LOADING_RESULTS_TRUE,
    SEARCH_TRIGGER_FALSE,
    SEARCH_TRIGGER_TRUE,
    SET_SORT_FILTER,
    SET_RESULTS_VIEW_PAGE,
    DELETE_SAVED_BORRADOR_KEY_POSITION,
    EDIT_SAVED_BORRADOR_KEY,
    EDIT_SAVED_BORRADOR_KEY_POSITION,
    UPDATE_FILTERS_EREASER,
    SET_TAB_SELECTED,
} from "./types";

export const inputSearchText = (input_text, visible=true) => ({
    type: INPUT_SEARCH_TEXT,
    input_text,
    visible
});

export const cleanSearchText = () => ({
    type: CLEAN_SEARCH_TEXT,
});

export const updateFilters = (filters) => ({
    type: UPDATE_FILTERS,
    filters,
});

export const updateFilter = (filter) => ({
    type: UPDATE_FILTER,
    filter,
});

export const setFiltersValues = (options) => ({
    type: SET_FILTERS_LIST_VALUES,
    options,
});

export const toggleFooter = () => ({
    type: TOGGLE_FOOTER,
});

export const saveSearchResults = (results) => ({
    type: SAVE_SEARCH_RESULTS,
    results,
});

export const saveDateResults = (dateResults) => ({
    type: SAVE_DATE_RESULTS,
    dateResults,
});

export const saveResults = (result) => ({
    type: SAVE_RESULT,
    result,
});

export const saveBorradores = (result) => ({
    type: SAVE_BORRADOR,
    result,
});

export const saveBorradoresConcepto = (result) => ({
    type: SAVE_BORRADOR_CONCEPTO,
    result,
});

export const deleteSavedResult = (savedResult) => ({
    type: DELETE_SAVED_RESULT,
    savedResult,
});

export const deleteSavedBorrador = (savedBorrador) => ({
    type: DELETE_SAVED_BORRADOR,
    savedBorrador,
});

export const deleteSavedBorradorKey = (idBorrador, key) => ({
    type: DELETE_SAVED_BORRADOR_KEY,
    idBorrador,
    key,
});

export const deleteSavedBorradorKeyPosition = (
    idBorrador,
    key,
    elementToDelete
) => ({
    type: DELETE_SAVED_BORRADOR_KEY_POSITION,
    idBorrador,
    key,
    elementToDelete,
});

export const deleteAllSavedBorrador = () => ({
    type: DELETE_ALL_BORRADOR,
});

export const editSavedBorradorKey = (idBorrador, key, value) => ({
    type: EDIT_SAVED_BORRADOR_KEY,
    idBorrador,
    key,
    value,
});

export const editSavedBorradorKeyPosition = (idBorrador, key, value) => ({
    type: EDIT_SAVED_BORRADOR_KEY_POSITION,
    idBorrador,
    key,
    value,
});

export const saveDocumentSearchText = (documentSearchText) => ({
    type: SET_DOC_SEARCH,
    documentSearchText,
});

export const switchLoadingResults = () => ({
    type: SET_LOADING_RESULTS,
});

export const switchLoadingToTrue = () => ({
    type: SET_LOADING_RESULTS_TRUE,
});

export const switchLoadingToFalse = () => ({
    type: SET_LOADING_RESULTS_FALSE,
});

export const searchTriggerFalse = () => ({
    type: SEARCH_TRIGGER_FALSE,
});

export const searchTriggerTrue = () => ({
    type: SEARCH_TRIGGER_TRUE,
});

export const updateSortType = (sortType) => ({
    type: SET_SORT_FILTER,
    sortType,
});

export const deleteSortType = () => ({
    type: SET_SORT_FILTER,
    sortType: {},
});

export const setResultsViewPage = (page) => ({
    type: SET_RESULTS_VIEW_PAGE,
    page,
});

export const updateFiltersEraser = (filtersEraser) => ({
    type: UPDATE_FILTERS_EREASER,
    filtersEraser,
});

export const setTabSelected = (tab) => ({
    type: SET_TAB_SELECTED,
    tab,
});
